var exports = {
  "kL": "x43aef4ae--f7d584--container",
  "lO": "x43aef4ae--f7d584--cta",
  "PX": "x43aef4ae--f7d584--benefits",
};

module.exports = exports;
